<template>
    <div>

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-6 searching">
                        <span class="h_page">Indikator Kinerja</span> <br> <br>
                    </div>
                    <div class="col-md-3">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button @click="Printing" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Cetak Data">
                                    <i class="material-icons">print</i>
                                </button>
                            </span>
                            <input type="text" class="form-control" >
                        </div> <br>
                    </div>
                </div>
            </div>




            <div class="col-xs-12 card">
                
        <!-- ============================================================ MULAI ======================================================================== -->
               
                <br>
                <div class="table-responsive" id="printMe">

                
               
                <div>
                    <table style="width: 100%">
                        <tr>
                            <td style="width: 25%" class="text-right">
                                <img src="images/logo konsel.png" alt="" width="50">
                            </td>
                            <td style="width: 50%" class="text-center h_kop_1">
                               <b>
                                    INDIKATOR KINERJA UTAMA PEMERINTAH DAERAH <br>
                                    KABUPATEN KONAWE SELATAN
                               </b>
                            </td >
                            <td style="width: 30%"></td>
                        </tr>
                    </table>
                </div>
                <br>
                    <!-- ===== TOTAL TABEL 55% UNTUK CETAK ===== -->
                    <table class="table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-success kepala_table_f tabel_center">
                            <th class="tabel_center text-center" rowspan="2" style="width:3%">No</th>
                            <th class="tabel_center text-center" rowspan="2" style="width:18%">KINERJA UTAMA (Sasaran Kinerja)</th>
                            <th class="tabel_center text-center" rowspan="2" style="width:17%">INDIKATOR KINERJA UTAMA</th>
                            <th class="tabel_center text-center" rowspan="2" style="width:17%">FORMULASI</th>
                        </tr>

                        </thead>
                        <tbody>
                        <tr class="h_cetak_2 tabel_top" v-for="(data, index) in list_data" :key="data.indikator_id">
                            <td class="text-center">{{index+1}}</td>
                            <td class="" >{{data.sasaran_uraian}}</td>
                            <td class="">{{data.uraian}}</td>
                            <td class="">{{data.rumus_satuan}}</td>
                        </tr>

                        </tbody>
                    </table>
                </div>

               



        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>



    </div>
</template>


<script>

    const ADD_URL = URL_APP+'api/v1/planning_indikator_kinerja/';



    export default {
        name: "planning_rpjmd",
        data() {
            return {
                list_data : []
            };
        },

        mounted() {

            // localStorage.sidemenu = 'planing';
            this.getDATA()

            
        },

        // =============================================================== METHODS =========================================================================
        methods : {
                getDATA : function(){
                    fetch(ADD_URL, {
                        method : 'GET',
                        headers : {
                            'content-type': 'application/json',
                            authorization : 'kikensbatara '+ localStorage.token
                        }
                    }).then(res => res.json()).then((res_data)=>{
                        this.list_data = res_data;
                        // this.cari_data();
                        // console.log(res_data);
                    })
                },
             
            // =================================== TAMBAHAN ==================================
                getRPJMD : function(){
                    fetch(ADD_URL_RPJMD, {
                        method : 'GET',
                        headers : {
                            'content-type': 'application/json',
                            authorization : 'kikensbatara '+ localStorage.token
                        }
                    }).then(res => res.json()).then((res_data)=>{
                        this.list_RPJMD = res_data;
                        this.cari_data();
                        // console.log(res_data);
                    })
                },
                getAspek_pembangunan : function(){
                    if (this.rpjmd_id == '') {
                        this.aspek_pembangunan_id = '';
                        this.aspek_fokus_pembangunan_id = '';
                    }
                    fetch(ADD_URL_APEK_PEMBANGUNAN, {
                        method : 'GET',
                        headers : {
                            'content-type': 'application/json',
                            authorization : 'kikensbatara '+ localStorage.token
                        }
                    }).then(res => res.json()).then((res_data)=>{
                        this.list_aspek_pembangunan = res_data;
                        this.cari_data();
                        // console.log(res_data);
                    })
                },
                getAspek_fokus_pembangunan : function(){
                    if (this.aspek_pembangunan_id == '') {
                        this.aspek_fokus_pembangunan_id = '';
                    }
                    fetch(ADD_URL_ASPEK_FOKUS_PEMBANGUNAN, {
                        method : 'POST',
                        headers : {
                            'content-type': 'application/json',
                            authorization : 'kikensbatara '+ localStorage.token
                        },
                        body: JSON.stringify({
                            aspek_pembangunan_id : this.aspek_pembangunan_id
                        })
                    }).then(res => res.json()).then((res_data)=>{
                        this.list_aspek_fokus_pembangunan = res_data;
                        this.cari_data();
                        console.log(res_data);
                    })
                },
            // =================================== TAMBAHAN ==================================
            // =================================== PAGINASI ==================================
                alertku : function(type, title){
                this.$swal({
                    type: type,
                    title: title,
                    showConfirmButton: false,
                    timer: 800
                });
                },

                btn_prev : function(){
                if(this.page_first>1){
                    this.page_first--
                }else{
                    this.page_first = 1;
                }
                this.getData();
                },

                btn_next : function(){
                if(this.page_first >= this.page_last){
                    this.page_first == this.page_last
                }else{
                    this.page_first++;
                }
                this.getData();
                },

                cari_data : function(){
                    this.page_first = 1;
                    this.getData();
                },
                format_uang : function(angka, prefix){
                    var rupiah = '';		
                    var angkarev = angka.toString().split('').reverse().join('');
                    for(var i = 0; i < angkarev.length; i++) if(i%3 == 0) rupiah += angkarev.substr(i,3)+'.';
                    return ''+rupiah.split('',rupiah.length-1).reverse().join('');
                },
                Printing : function(){
                    // printMe
                    var elem = document.getElementById("printMe");
                    var domClone = elem.cloneNode(true);

                    var $printSection = document.getElementById("printSection");

                    if (!$printSection) {
                        var $printSection = document.createElement("div");
                        $printSection.id = "printSection";
                        document.body.appendChild($printSection);
                    }

                    $printSection.innerHTML = "";
                    $printSection.appendChild(domClone);
                    window.print();

                },
            // =================================== PAGINASI ==================================

        },
        // =============================================================== METHODS =========================================================================

    };
</script>
